module.exports = __webpack_public_path__ + "img/header-icon-catalog.02073813.svg";